// Core packages
import { Injectable } from '@angular/core';

// Third party packages
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Custom packages
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';

@Injectable({
  providedIn: 'root'
})
export class TankService {

  /**
   * Class constructor
   */
  constructor(
    private apiService: ApiService,
    private helperService: HelperService
  ) { }


  /**
   * Upload file into tank
   *
   * @since 1.0.0
   *
   * @param
   */
  createDoc(data: any): Observable<any> {
    return this.apiService
      .apiCall("POST", `tank`, data)
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }

  /**
   * Search docs of all condoStructure
   *
   * @since 1.0.0
   *
   * @param
   */
  getList(start?: number, limit?: number, sort?: string, sortVersus?: string, search?: any): Observable<any> {
    const params: any = { start, limit, sort, sortVersus };
    if (search) {
      Object.keys(search).forEach(key => {
        const newParamKey = `search[${key}]`;
        const newParamValue = search[key];
        params[newParamKey] = newParamValue;
      });
    }
    return this.apiService
      .apiCall("GET", `tank`, params)
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }

  /**
   * Upload file into tank
   *
   * @since 1.0.0
   *
   * @param
   */
  updateDoc(docId: string, data: any): Observable<any> {
    return this.apiService
      .apiCall("PUT", `tank/${docId}`, data)
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }

  /**
   * Update doc status
   *
   * @since 1.0.0
   *
   * @param
   */
  updateDocStatus(docId: string, viewed: boolean): Observable<any> {
    return this.apiService
      .apiCall("PUT", `tank/${docId}/update-status`, { viewed })
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }

  /**
   * Delete permanently a tank
   *
   * @since 1.0.0
   *
   * @param tankDocId ID of the tank document
   */
  delete(tankDocId: string): Observable<any> {
    return this.apiService.apiCall('DELETE', `tank/${tankDocId}`);
  }
}
